import {location} from '../menu.data';

type TypeUrl = keyof typeof location;

export const findValidUrl = (url: string): string => {
  return location[url as TypeUrl]
    ? url
    : url === ''
      ? '/'
      : findValidUrl(url.slice(0, url.match(/(\/\w+(\/)?)+/)![0].length - 1));
};

type TypesIsSublocationReturn = {path: string} | false;

export const isSublocation = (url: string, id?: string): TypesIsSublocationReturn => {
  const parsedUrl = url.match(/\/\w+/g);

  if (location[url as TypeUrl] || url === '') return false;

  if (parsedUrl && parsedUrl.length < 2) return false;

  return !!parsedUrl && parsedUrl[parsedUrl?.length - 1].split('/').join('') === id
    ? {path: parsedUrl.slice(0, parsedUrl.length - 1).join('')}
    : false;
};
